import React, { FC } from 'react'

//* styles
import { RichTextWrapper } from '../../../styles/global'
import { FeaturedAsset } from '../featuredAsset/featuredAsset'
import GlobalContainer from '../globalContainer'
import { BlockContainer, BlockTitle } from './style'

//* utils
import { ComponentParagraphBlock } from '../../../models/components/paragraphBlock'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

type Props = {
  data: ComponentParagraphBlock
}

const ParagraphBlock: FC<Props> = ({ data }) => {
  const paragraphBlockData = {
    headline: data.headline || '',
    body: data.body || '',
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'Large',
    orangeDivider: data.orangeDivider || false,
    finePrint: data.finePrint || '',
    quoteBlockTheme: data.theme || 'Grey',
    centerAlignment: data.centerAlignment || '',
    anchorLink: data.anchorLink || '',
    useCase: data.useCase || '',
    featuredAsset: data.featuredAsset || '',
  }
  const fullWidthClass =
    paragraphBlockData.useCase === 'Full width' ? 'ParagraphBlock--fullWidth' : ''
  const containerClassName = `${fullWidthClass} ${
    paragraphBlockData.featuredAsset ? '' : 'full-paragraph'
  }`

  return (
    <BlockContainer
      data-cy="paragraphBlock"
      $orangeDivider={paragraphBlockData.orangeDivider}
      $topPadding={paragraphBlockData.topPadding}
      $bottomPadding={paragraphBlockData.bottomPadding}
      $quoteBlockTheme={paragraphBlockData.quoteBlockTheme}
      $centerAlignment={paragraphBlockData.centerAlignment}
      className={containerClassName}
      id={data?.anchorLink?.identifier}>
      <GlobalContainer className="ParagraphBlock__Container">
        {paragraphBlockData.headline && (
          <div className="paragrapghBlock__Title_container">
            <BlockTitle type="header2" className="paragrapghBlock__Title">
              {formatInlineCode(paragraphBlockData.headline)}
            </BlockTitle>
          </div>
        )}

        {paragraphBlockData.body && (
          <div className="ParagraphBlock__Body">
            {paragraphBlockData.body && renderRichText(paragraphBlockData.body)}
          </div>
        )}

        {paragraphBlockData.finePrint && (
          <RichTextWrapper $type="finePrint">
            {renderRichText(paragraphBlockData.finePrint)}
          </RichTextWrapper>
        )}
      </GlobalContainer>
      {paragraphBlockData.useCase === 'Full width' && paragraphBlockData.featuredAsset && (
        <div className="fullwidth__featuredAsset">
          <FeaturedAsset data={paragraphBlockData.featuredAsset} />
        </div>
      )}
    </BlockContainer>
  )
}

export default ParagraphBlock
